// extracted by mini-css-extract-plugin
export var buttonWrapper = "ComparisonTable-module--buttonWrapper--e0955";
export var cardWrapper = "ComparisonTable-module--cardWrapper--078e5";
export var compareMore = "ComparisonTable-module--compareMore--bd377";
export var container = "ComparisonTable-module--container--f3b14";
export var headline = "ComparisonTable-module--headline--567ed";
export var richText = "ComparisonTable-module--richText--67a85";
export var table = "ComparisonTable-module--table--d7fbf";
export var text = "ComparisonTable-module--text--4e21f";